export default keyDownEvent => (keyDownEvent.key === 'Enter' || keyDownEvent.key === 'NumpadEnter')



// WEBPACK FOOTER //
// ./src/utils/isEnterPressed.js